import { Injectable } from '@angular/core';
import type { DateTimeSettings } from '@cdw-ae/common-data';
import {
  toTimezone,
  toUTC,
  toISOInTimezone,
  isValidTimezone,
  format,
  formatDate,
  formatTime,
  formatForGrid,
  formatDateTime,
  formatDateOnly,
  formatTimeOnly,
  getDateOffsetInDays,
  formatDuration,
  formatAbsoluteDateTime,
  formatTimeAgo,
} from '@cdw-ae/date-time-service';
import type { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class DateTimeAngularService {
  toTimezone(utcDate: Date | string, timezone: string): DateTime {
    return toTimezone(utcDate, timezone);
  }

  toUTC(localDate: Date | string, timezone: string): Date {
    return toUTC(localDate, timezone);
  }

  toISOInTimezone(date: Date | string, timezone: string): string {
    return toISOInTimezone(date, timezone);
  }

  isValidTimezone(timezone: string): boolean {
    return isValidTimezone(timezone);
  }

  format(
    date: Date | string,
    settings: DateTimeSettings,
    includeTime = true
  ): string {
    return format(date, settings, includeTime);
  }

  formatDate(date: Date | string, settings: DateTimeSettings): string {
    return formatDate(date, settings);
  }

  formatTime(date: Date | string, timezone: string): string {
    return formatTime(date, timezone);
  }

  formatForGrid(
    value: Date | string | null | undefined,
    settings: DateTimeSettings,
    includeTime = true
  ): string {
    return formatForGrid(value, settings, includeTime);
  }

  formatDateTime(
    date: Date | string,
    timezone: string,
    dateFormat: string,
    timeFormat: string
  ): string {
    return formatDateTime(date, timezone, dateFormat, timeFormat);
  }

  formatDateOnly(
    date: Date | string,
    timezone: string,
    dateFormat: string
  ): string {
    return formatDateOnly(date, timezone, dateFormat);
  }

  formatTimeOnly(
    date: Date | string,
    timezone: string,
    timeFormat: string
  ): string {
    return formatTimeOnly(date, timezone, timeFormat);
  }

  static getDateOffsetInDays(days: number): string {
    return getDateOffsetInDays(days);
  }

  static formatDuration(milliseconds: number | null | undefined): string {
    return formatDuration(milliseconds);
  }

  static formatAbsoluteDateTime(value: string | Date): string {
    return formatAbsoluteDateTime(value);
  }

  static formatTimeAgo(value: string | Date, showSeconds = false): string {
    return formatTimeAgo(value, showSeconds);
  }
}
